import React, { useEffect } from "react";
import neuBirdLogo from "../assets/NeuBird-Horizontal-Default.svg";

const COMPLETE_PAGE_PATH = "/registrations/complete";
const COMPLETE_PAGE_TITLE = "Registration Complete | Hawkeye";

const SuccessPage = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    document.title = COMPLETE_PAGE_TITLE;

    const skipTracking = window.__skipTracking || sessionStorage.getItem("nb_skip_tracking");
    if (skipTracking) {
      console.log("[Hawkeye Registration] Skip tracking active – completion page view not sent");
    }

    if (!skipTracking) {
      const pageViewParams = {
        page_path: COMPLETE_PAGE_PATH,
        page_title: COMPLETE_PAGE_TITLE,
      };

      if (typeof window.gtag === "function") {
        window.gtag("event", "page_view", pageViewParams);
      }

      if (window.dataLayer) {
        window.dataLayer.push({
          event: "virtualPageView",
          ...pageViewParams,
        });
      }

      if (window.dataLayer) {
        window.dataLayer.push({ event: "gtm.historyChange" });
      }
    }

    const redirectTimer = setTimeout(() => {
      window.location.href = "https://help.neubird.ai/introduction/quick_start/";
    }, 30000);

    return () => clearTimeout(redirectTimer);
  }, []);

  return (
    <>
      {/* Top bar */}
      <div className="topbar">
        <span className="topbar-text">
          NewBird by NeuBird &mdash; free credits and daily reports for startups.
        </span>
      </div>

      {/* Nav */}
      <nav className="site-nav">
        <a className="nav-logo" href="https://neubird.ai">
          <img src={neuBirdLogo} alt="NeuBird AI" />
        </a>
        <span className="nav-cta"></span>
      </nav>

      {/* Success content */}
      <div className="success-page">
        <div className="success-card">
          <div className="success-icon">&#10003;</div>
          <h2>You're all set!</h2>
          <p>
            You will receive an email from <strong>sre@neubird.ai</strong> in
            about 5 minutes with setup instructions for your NewBird account.
          </p>
          <p>
            Your daily reports &mdash; Predictive Risk, Cost Optimization, Observability Posture,
            and Security Assessment &mdash; will start arriving in your inbox tomorrow morning.
          </p>
          <p className="success-redirect">
            Let's take a look at the docs. Redirecting in 30 seconds...
          </p>
        </div>
      </div>

      {/* Footer */}
      <footer className="site-footer">
        <span className="footer-text">&copy; 2026 NeuBird AI, Inc.</span>
        <div className="footer-links">
          <a href="https://neubird.ai/privacy" target="_blank" rel="noopener noreferrer">Privacy</a>
          <a href="https://neubird.ai/terms" target="_blank" rel="noopener noreferrer">Terms</a>
          <a href="https://neubird.ai/security" target="_blank" rel="noopener noreferrer">Security</a>
          <a href="https://neubird.ai/contact" target="_blank" rel="noopener noreferrer">Contact</a>
        </div>
      </footer>
    </>
  );
};

export default SuccessPage;
